import userinvitedform from './userinvited-form'

const textforreplace = [
  'First Name',
  'Last Name',
  'Email',
  'Company',
  'Select language',
  'Select country',
  'Password',
  'Confirm Password',
  'I accept the',
  'Terms of Service and Privacy policy',
  'Suscription to newsletter',
  'I am a Distributor',
  'Complete your data',
  'Update data',
  'Minimum 14 characters',
  'Logout',
  'Cancel',
  'Do you really want to logout?',
  'Sign In'
]

const replacetexts = content => {

  textforreplace.forEach(key => {

    content = content.replace(key, __(key))
  })

  return content
}

(function($) { 

  window.showcompletedata = (keyinv) => {

    $('html').css('overflow', 'hidden')
    $('body').addClass('UserInvited')
    $('.xoo-el-container.xoo-el-popup-active')
    .attr('style', 'visibility: hidden !important');

    $('body').append(userinvitedform(keyinv))

    const $userinvited = $('#UserInvited')
    const $userform = $('#UserInvited .UserForm')
    const $close = $userform.find('.Close')
    const $form = $userform.find('form.xoo-el-form-register') 
    
    $form.html(replacetexts($form.html()))

    const $fieldscontent = $form.find('.xoo-aff-fields').eq(0)

    const calls = [
      '/wp-json/academy/user/categories',
      '/wp-json/academy/user/languages',
      '/wp-json/academy/user/countries'
    ]
    .map(call => fetch(
      call,
      {
        method: 'GET',
        headers: {
          'X-WP-Nonce': academy_web_site.nonce
        }
      }
    ))

    Promise.all(calls)
    .then(results => Promise.all(results.map(response => response.json())))
    .then(datas => {
      
      const industries = datas[0]
      const languages = datas[1]
      const countries = datas[2]
      const encriptdata = window.academystatus.checkin?.data

      console.log(encriptdata)

      if(
        !encriptdata
      ) {

        $userinvited.remove()

        return
      }

      const userdata = JSON.parse(atob(encriptdata))

      if(
        !userdata.found
      ) {

        $userinvited.remove()

        return
      }

      $userinvited.css('display', 'flex')

      $fieldscontent.find('input[name="xoo_el_reg_fname"]').val(userdata.firstname || '') 
      $fieldscontent.find('input[name="xoo_el_reg_lname"]').val(userdata.lastname || '')
      $fieldscontent.find('input[name="xoo_el_reg_email"]').val(userdata.email || '')
      $fieldscontent.find('input[name="academy_register_company"]').val(userdata.company || '')

      const $selectindustry = $fieldscontent.find('.xoo-aff-select_list[name="academy_register_industry"]')
      const industriesoptionselect = `<option value="">${__('Select industry')}</option>`
      const industriesoptions = industries
      .map(industry => {

        industry.name = __(industry.name)
        return industry
      })
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(option => `<option value="${option.slug}" ${ option.slug == userdata.industry ? 'selected="selected"' : '' }>${option.name}</option>`)
      .join('')
      $selectindustry.html(industriesoptionselect + industriesoptions);

      const $selectcountry = $fieldscontent.find('.xoo-aff-select_list[name="academy_register_country"]') 
      const countriesoptionselect = `<option value="">${__('Select country')}</option>`
      const countriesoptions = Object.keys(countries)
      .map(key => `<option value="${key}" ${ key == userdata.country ? 'selected="selected"' : '' }>${ countries[key] }</option>`)
      .join('')
      $selectcountry.html(countriesoptionselect + countriesoptions);        

      const $selectlanguage = $fieldscontent.find('.xoo-aff-select_list[name="academy_register_language"]') 
      const languageoptionselect = `<option value="">${__('Select language')}</option>`
      const languagesoptions = Object.keys(languages)
      .map(key => `<option value="${key}" ${ key == userdata.language ? 'selected="selected"' : '' }>${ languages[key].name }</option>`)
      .join('')
      $selectlanguage.html(languageoptionselect + languagesoptions);      

      const $arearegistera = $fieldscontent.find('.AcademyConditionsInfoA')
      $arearegistera.replaceWith('<div class="AcademyConditionsInfoA">' +
        __('Conditions-Auhorize') +
      '</div>')

      const $arearegisternewsletter = $fieldscontent.find('.AcademyRegisterNewsletter')
      $arearegisternewsletter.html($arearegisternewsletter.html().replace(
        'Subscription to newsletter',
        __('Conditions-Email updates')
      ))

      const $arearegistermailpartners = $fieldscontent.find('.AcademyRegisterMailpartners')
      $arearegistermailpartners.html($arearegistermailpartners.html().replace(
        'Partners mails',
        __('Conditions-Email news')
      ))

      const $arearegisterb = $fieldscontent.find('.AcademyConditionsInfoB')
      $arearegisterb.replaceWith('<div class="AcademyConditionsInfoB">' +
      __(`Conditions-Personal data`) +
      '</div>')      

      const validatecompletefields = {
        'input[name="xoo_el_reg_fname"]': {
          type: 'input',
          invalid: __('Please fill this field')
        },
        'input[name="xoo_el_reg_lname"]': {
          type: 'input',
          invalid: __('Please fill this field')
        },
        'input[name="xoo_el_reg_email"]':  {
          type: 'input',
          invalid: __('Invalid email')
        },
        'input[name="academy_register_company"]':  {
          type: 'input',
          invalid: __('Please fill this field')
        },
        'select[name="academy_register_industry"]':  {
          type: 'select',
          invalid: __('Please select an option')
        },
        'select[name="academy_register_country"]':  {
          type: 'select',
          invalid: __('Please select an option')
        },
        'select[name="academy_register_language"]':  {
          type: 'select',
          invalid: __('Please select an option')
        },
        'input[name="xoo_el_reg_pass"]':  {
          type: 'input',
          invalid: __('Please fill this field')
        },
        'input[name="xoo_el_reg_pass_again"]':  {
          type: 'input',
          invalid: __('Please fill this field')
        }
      }

      Object.keys(validatecompletefields)
      .forEach(key => {

        const $field = $fieldscontent.find(key).eq(0)
        $field.attr('oninvalid', 'setCustomValidity(\'' + validatecompletefields[key].invalid + '\')')
        if(validatecompletefields[key].type == 'input'){
          $field.attr("onblur", "setCustomValidity('')")
          $field.attr('oninput', "setCustomValidity('')")
        }
        if(validatecompletefields[key].type == 'select'){
          // $field.attr("onblur", "setCustomValidity('')")
          $field.attr('onchange', "setCustomValidity('')")
        }
      })

      $close
      .on(
        'click',
        function() {
          
          window.location.replace('/wp-login.php?action=logout')
        }
      )            

      $('input[name="xoo_el_reg_pass"], input[name="xoo_el_reg_pass_again"]')
      .each(function() {

        const $field = $(this)
        $field.after(`
          <span 
            class="ShowPassword dashicons dashicons-visibility" 
            aria-hidden="true"
          ></span>
        `)
        $field.siblings('.ShowPassword')
        .on(
          'touchstart mousedown',
          function() {

            $(this).addClass('Showing')          
            $field.attr('type', 'text')
          }
        )
        .on(
          'touchend mouseup mouseleave',
          function() {

            $(this).removeClass('Showing')          
            $field.attr('type', 'password')
          }
        )
      })
    })
  }

  const urlParams = new URLSearchParams(window.location.search)

  const keyinv = urlParams.get('keyinv')
  if(keyinv) { 

    window.showcompletedata(keyinv)

    window.constrictinviteform = () => {

      $('#UserInvited .UserForm').addClass('Constricted')
    }
  }

  const weldingshopaccess = urlParams.get('weldingshopaccess')
  if(weldingshopaccess == 'denied') { 

    
  }

})(jQuery)